import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const replenishmentsystem = createApi({
    reducerPath: 'replenishmentsystem',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getSetting: builder.mutation({
            query: (param) => ({
                url: 'replenishmentsystem/getSetting',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getOutlets: builder.mutation({
            query: (param) => ({
                url: 'replenishmentsystem/getOutlets',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getData: builder.mutation({
            query: (param) => ({
                url: 'replenishmentsystem/getDataView',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        saveSetting: builder.mutation({
            query: (param) => ({
                url: 'replenishmentsystem/saveSetting',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetSettingMutation, useGetOutletsMutation, useGetDataMutation, useSaveSettingMutation } = replenishmentsystem;
export default replenishmentsystem;